

<template>
	<div class="product-infos p-5 d-flex align-items-center justify-content-center" v-move-to="`body`" :class="{mobile:app.useMobileVersion, 'single-image':product.images.length < 2}">
		<div class="inner" :class="{out:out}" v-touchy:clickoutside="onClickClose">
			
			<div class="d-flex align-items-center header-box">
				<div class="p-2 p-md-5 icon-box d-flex align-items-center justify-content-center" :class="`ic-${product.icon}`">
					<i class="icon"></i>
				</div>
				<div class="px-5 px-md-8 py-2 d-flex">
					<h1 v-if="product.title" class="mr-2" v-html="product.title"></h1>
					<h2 v-if="product.subtitle" v-html="product.subtitle"></h2>
				</div>
				<a @click="onClickClose" class="close p-2">
					<i class="fal fa-times"></i>
				</a>
			</div>

			<div class="content">

				<flickity ref="flickity" :options="flickityOptions">
					<div class="item" v-if="product.images" v-for="(item, index) in product.images">
						<template v-if="item.type == 4">
							<div class="embed-responsive-16by9 embed-responsive">
								<video controls playsinline autoplay>
									<source :src="item.path" type="video/mp4" />
								</video>
							</div>
						</template>
						<template v-if="item.type == 2">
							<div class="image" :style="getImage(item)">	
							</div>
						</template>
					</div>
				</flickity>
				
			</div>

			<div class="px-10 pt-10 pb-7 bodytext" v-if="product.bodytext" v-html="product.bodytext"></div>

		</div>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'
import Flickity from 'vue-flickity';

export default {
	components: {
    	Flickity
 	},
	store,
	props: ['product'],
	data() {
		return {
			out: false,
			flickityOptions: {
				initialIndex: 0,
				prevNextButtons: true,
				pageDots: true,
				adaptiveHeight: true,
			}
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
	},

	mounted() {
		this.out = false;
	},

	methods: {
		getImage( item ) {
			var img = this.app.useMobileVersion ? item.path : item.path;
			return {
				'background-image': `url(${img})`
			}
		},
		showPdf( event, pdf ) {
			EventBus.$emit('show-pdf', this.createEventParameters(event, pdf));
		},
		createEventParameters( event, pdf ) {
			return Object.assign({
				product: this.product,
				pdf: pdf,
				$el: this.$el,
				originalEvent: event,
			});
		},
		onClickClose( $event ) {
			this.out = true;
			setTimeout(() => {
				this.$emit('close-clicked', this.createEventParameters($event))
			}, 300);
		}
	}

}
</script>


<style scoped lang="scss">

	a {
		cursor: pointer;
	}
	.header-box {
		position: relative;
	}
	.icon-box {
		background: #dfe1e5;
		width: 40px;
		height: 40px;
		@media ($min-device-width-md) {
			width: 60px;
			height: 60px;
		}
	}
	.icon {
		width: 100%;
		height: 100%;
		display: block;
		&:after {
			content: '';
			width: 100%;
			height: 100%;
			background-size: cover;
			display: block;
		}
	}		

	.product-infos {

		font-family: $font-condensed;
		font-size: 1rem;
		color: #555;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;

		@include position( absolute, 0 0 0 0, 4000 );
		
		@media ($min-device-width-md) {
			font-size: 1.1rem;
		}

	}

	.inner {
		background: #fff;
		box-shadow: 0 0 8px rgba(#000, 0.3);
		transition: 0.3s all cubic-bezier(0.5, 0, 0.75, 0);
		&.out {
			opacity: 0;
			transform: scale(0.9);
		}
		width: 100%;
		@media ($min-device-width-md) {
			width: 80%;
			max-width: 800px;
		}
	}

	.bodytext {
		font-family: $font-sans;
		font-size: 1.4rem;
		line-height: 1.4;
		p {
			margin: 0 0 5px 0;
		}
	}

	.btn-primary {
		color: #fff;
		border: none;
		border-radius: 0;
		background: #004176;
		text-transform: uppercase;
		&:hover {
			color: #fff;
			background: lighten(#004176, 15%);
		}
	}

	.close {
		font-size: 2.5rem;
		color: #333;
		opacity: 1;
		@include position( absolute, 2px 5px auto auto, 100 );
		@media ($min-device-width-md) {
			top: 10px;
			right: 15px;
		}
	}

	.item {
		width: 100%;
		display: none;
	}

	.flickity-slider .item {
		display: block;
	}

	.image {
		background: #ddd none center center no-repeat;
		padding-top: 56%;
		background-size: cover;
	}
	.mobile .image {
		padding-top: 67%;				
	}

	h1, h2 {
		font-family: $font-condensed;
		text-transform: uppercase;
		font-size: 1.5rem;
		line-height: 1;
		@media ($min-device-width-md) {
			font-size: 2rem;
		}
		margin: 0 0 0.1rem 0;
		letter-spacing: 0.06em;
		color: #004982;
	}
	h1 {
		font-weight: 600;
	}
	h2 {
		font-weight: 300;
		color: #999;
	}
	
</style>

<style lang="scss">
	.product-infos {
		ul {
			padding: 0 0 0 20px;
			margin: 0;
		}
	}
	.pflege ~ .product-infos {
		border-color: #5db9da;
	}
	.single-image {
		.flickity-page-dots,
		.flickity-button {
			display: none;
		}
	}
</style>
